module.exports = __webpack_public_path__ + "static/media/muni-logo.b24790a9.svg";